import { SET_SALES_ORDER_CONFIG } from '../types/salesOrder'

import { getSalesOrderConfigAPI, updateSalesOrderConfigAPI } from '../api/salesOrder'

import { addMessageCurry, commonActionAPIHit } from '../utils/api'

export const setSalesOrderConfig = (payload) => ({
  type: SET_SALES_ORDER_CONFIG,
  payload,
})

export const getSalesOrderConfig = (groupName) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getSalesOrderConfigAPI(groupName), dispatch).then((res) => {
        dispatch(setSalesOrderConfig(res))
        resolve(res)
      })
    })
  }
}

export const updateSalesOrderConfig = (data, groupName) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateSalesOrderConfigAPI(data, groupName), dispatch).then((data) => {
        resolve(data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/salesOrder.js